import createChainablePropType from './createChainablePropType';

const domElementPropType = (props, propName, componentName) => {
  const value = props[propName];
  if (value == null || typeof value === 'object' && value.nodeType === 1) return null;
  return new Error(`${componentName}: Invalid ${propName} value. Expected a DOM element.`);
};

export default createChainablePropType(domElementPropType, 'DOM element');